import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Handles scroll on route change: scroll to top for normal routes,
// smooth-scroll to the hashed section (e.g. /#brands) when a hash is present.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const scrollToTarget = () => {
        const el = document.getElementById(id);
        if (!el) return;
        // Guard: if already close to the intended position (-80 offset from top),
        // skip re-invoking so we don't disturb an in-flight smooth scroll.
        const currentTop = el.getBoundingClientRect().top;
        if (Math.abs(currentTop - 80) < 40) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, force: true });
        else el.scrollIntoView({ behavior: "smooth" });
      };

      const timers = [
        setTimeout(scrollToTarget, 300),
        setTimeout(scrollToTarget, 1200),
        setTimeout(scrollToTarget, 2200),
      ];

      const onLoad = () => scrollToTarget();
      if (document.readyState !== "complete") {
        window.addEventListener("load", onLoad, { once: true });
      }

      return () => {
        timers.forEach(clearTimeout);
        window.removeEventListener("load", onLoad);
      };
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true, force: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
